export const translation = {
  header: {
    items: [
      {
        name: 'Начало',
        href: '/',
      },
      {
        name: 'Система',
        href: '#system',
      },
      {
        name: 'Модул',
        href: '#module',
      },
      {
        name: 'Монтаж',
        href: '#montage',
      },
      {
        name: 'EasyLan',
        href: 'https://www.easylan.de/',
        newTab: true,
      },
    ],
    language: 'Език',
  },

  easylan: {
    fixLink: 'fixLink<sup>®</sup>',
    hero: {
      title: {
        text1: 'Леснота',
        text2: 'във връзка',
      },
      subtitle: 'Вашата връзка към бъдещето',
      cta: 'повече',
    },
    handling: {
      title: 'ИНТУИТИВНО УПРАВЛЕНИЕ СРЕЩА НАПРЕДНАЛА ТЕХНОЛОГИЯ',
      vorreiterPrefix: 'Комбинацията от прецизност и функционален дизайн прави ',
      vorreiterSuffix: ' водещ избор в технологията за мрежи.',
      experte: ' предлага ефективни 360° решения, които оптимално комбинират дизайн и производителност за минимизиране на сложността.',
      pionier: ' е пионер в преобразяването на работни пространства, комбиниращ експертност с интуитивно управление.',
    },
    download: {
      prefix: 'Преглед ',
      suffix: ' - Изтегляне на системата',
      cta: 'Изтегли',
      href: 'https://fixlink.eu/PUBLIC_STORAGE/FixLink_System_Uebersicht_2024_DE_v2.pdf',
    },
    system: {
      titleLabel: 'Преглед на продукта',
      title: 'FIXLINK<sup>®</sup> - СИСТЕМА',
    },
    module: {
      overview: 'Преглед на изтеглянето',
      accordion: {
        ghmtCertificates: {
          title: 'Сертификати GHMT',
          text: 'Ние разчитаме на GHMT и тяхната програма за премиум верификация за независимо удостоверяване на качеството на нашите мрежови продукти. Така, въз основа на 20 години опит, гарантираме най-високите стандарти за продуктите за нашите клиенти.',
        },
        datasheets: {
          title: 'Технически спецификации',
          text: 'Тук ще намерите всички необходими технически спецификации. Изтеглете ги и имате цялата информация на едно място.',
        },
        compatibilitySheets: {
          title: 'Списъци за съвместимост',
          text: '',
        },
        excelTemplates: {
          title: 'Шаблони за Excel за етикетни прозорци',
          text: '',
        },
      },
    },
    video: {
      title: 'ИНСТРУКЦИИ ЗА МОНТАЖ',
      text: 'Гледайте видеото или просто изтеглете PDF тук',
      manual: {
        title: 'ИНСТРУКЦИИ ЗА МОНТАЖ:',
      },
    },
    separator: {
      title: 'Повече от просто връзка',
      title2: 'Открийте вселената на EasyLan',
      text: 'Открийте разнообразието от иновативни мрежови решения в EasyLan. Индивидуално адаптирани за вас. Променящата играта за вашата мрежа: Нашите системи за кабели и решения за управление на кабели.',
      cta: 'повече',
    },
    combination: {
      bau: {
        prefix: 'Изпитайте максимална адаптивност и качество с ',
        text: ' носещите конструкции на EasyLan ',
        suffix: 'директно от Европа.',
      },
      intelligent: {
        prefix: 'Вашата мрежа',
        text: ' по поръчка ',
        suffix: 'с конфигурируемата сплайс кутия на EasyLan',
      },
      fixlink: {
        prefix: 'С нашите ',
        suffix: ' продукти можете дългосрочно да подобрите офис сградите си.',
      },
      hds: {
        prefix: 'Системата',
        text: ' EasyLan® H.D.S. ',
        suffix: 'съчетава лесност на инсталиране и поддръжка както никоя друга система за трънково кабелиране на пазара.',
      },
    },
    recommended: {
      titleLabel: 'Препоръчани',
      title: 'fixLink<sup>®</sup> - СИСТЕМА',
      text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      items: [
        { imgName: 'a', name: 'FIXLINK A', text: 'Lorem ipsum dolor met' },
        { imgName: 'b', name: 'FIXLINK B', text: 'Lorem ipsum dolor met' },
        { imgName: 'c', name: 'FIXLINK C', text: 'Lorem ipsum dolor met' },
        { imgName: 'd', name: 'FIXLINK D', text: 'Lorem ipsum dolor met' },
        { imgName: 'e', name: 'FIXLINK E', text: 'Lorem ipsum dolor met' },
      ],
    },
    guarantee: [
      {
        title: 'Гаранция за продукта',
        text: [
          'Гаранцията за продукта включва всички компоненти на ',
          '- оптично или медно кабелно система, инсталирани и тествани от квалифициран инсталатор според насоките на ',
          ' и приложимите стандарти за инсталиране EN50174.',
        ],
      },
      {
        title: 'Гаранция за производителност',
        text: [
          'Гаранцията за производителност, освен приложението (Ethernet, Fiber Channel, ATM и т.н.), гарантира също така свойствата на системата включително скоростите на предаване (10MBit, 100MBit, 1GBit и 10GBit).',
        ],
      },
      {
        title: 'Гаранция за приложение',
        text: [
          'Гаранцията за приложение осигурява всички специфицирани приложения (Ethernet, Fiber Channel, ATM и т.н.), които се базират на стандартите за кабелиране ISO/IEC 11801, EN50173 и EIA/TIA 568B валидни към момента на инсталиране.',
        ],
      },
    ],
    end: {
      title: 'ВРЪЗКИТЕ НИКОГА НЕ СА БИЛИ ТОЛКОВА ЛЕСНИ.',
      text: 'Интуитивно управление среща напреднала технология; открийте безпроблемната връзка на бъдещето. fixLink.',
    },
    categoryData: {
      modules: 'Модули за свързване',
      csm_FixLink_Pro03_b20813b518: {
        name: 'Pro RJ45 Keystone модул Cat. 6A ISO/IEC, екраниран',
        text: 'С fixLink<sup>®</sup> Pro RJ45 Keystone модула, потребителите получават модул RJ45 гнездо от най-високо качество. FixLink® Pro RJ45 Keystone модула може да бъде сглобен със странични резци за по-малко от минута. Благодарение на свободно достъпната контактна зона е гарантирано перфектно качество на сглобяване и с това гарантирана предавателна производителност. Специалната контактна геометрия в комбинация с 30 μ" златно покритие гарантира 4PPoE според IEEE 802.3bt при всички условия. Материалът на корпуса е направен от никелиран цинков леяр и така отговаря на най-високите екологични и механични изисквания. В комбинация със съвместимата по дизайн модулна поставка е възможна комбинация с всички програми за превключване. Те се доставят в екологично чиста картонена опаковка.',
        ghmtCertificates: [
          {
            name: 'Сертификат PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Pro+RJ45+Keystone-Modul/z5951i-20.pdf',
          },
          {
            name: 'Сертификат за постоянна връзка',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Pro+RJ45+Keystone-Modul/z8144a-23.pdf',
          },
        ],
      },
      csm_fixLink_Extender_a0613ee77a: {
        name: 'Удължител',
        text: 'С fixLink<sup>®</sup> удължителя, кабелите могат да бъдат удължени без много усилия. Освен това, извадените от употреба линии могат да бъдат реактивирани и удължени до следващото необходимо свързване. Така се използва оптимално ограниченото пространство в кабелния канал. Удължителят се закрепва лесно в края на инсталирания кабел в канала или на стената. След инсталацията, така удължената линия може да се използва за предавания 10-gigabit Ethernet до максималната дължина на връзката и поддържа PoE+ (Power over Ethernet).',
      },
      csm_fixLinkRJ45Plug_Katalog_c858f0a6ed: {
        name: 'Щепсел RJ45 Cat. 6A ISO/IEC екраниран',
        text: 'С fixLink<sup>®</sup> RJ45 щепсел модула, потребителите получават полево конфигурируем RJ45 щепсел модул от най-високо качество и гъвкавост. Специалната контактна геометрия в комбинация с 50 μ" златно покритие гарантира 4PPoE според IEEE 802.3bt при всички условия. Материалът на корпуса е направен от никелиран цинков леяр и така отговаря на най-високите екологични и механични изисквания. Различни сертификации (текущ списък: www.easylan.de) от независими изпитвателни лаборатории допълват най-високите изисквания за качество на системата fixLink<sup>®</sup>.',
      },
      csm_FixlinkUTP_e5de94d502: {
        name: 'RJ45 Keystone модул Cat.6A EIA/TIA, неекраниран',
        text: 'С fixLink<sup>®</sup> RJ45 Keystone модула (съвместим с PoE+), потребителите получават модул RJ45 гнездо от най-високо качество. FixLink® RJ45 Keystone модула може да бъде сглобен със странични резци за по-малко от минута. Благодарение на свободно достъпната контактна зона е гарантирано перфектно качество на сглобяване и с това гарантирана предавателна производителност. Материалът на корпуса е направен от поликарбонат и така отговаря на най-високите екологични и механични изисквания. В комбинация със съвместимата по дизайн модулна поставка е възможна комбинация с всички програми за превключване. Различни сертификации от независими изпитвателни лаборатории допълват най-високите изисквания за качество на модула fixLink<sup>®</sup> SL Keystone. Те се доставят в екологично чиста картонена опаковка.',
      },
      fixLink_SL_02: {
        name: 'SL RJ45 Keystone модул Cat.6A ISO/IEC, екраниран',
        text: 'С fixLink<sup>®</sup> SL RJ45 Keystone модула, потребителите получават модул RJ45 гнездо от най-високо качество. FixLink® SL RJ45 Keystone модула може да бъде сглобен със странични резци за по-малко от минута. Благодарение на свободно достъпната контактна зона е гарантирано перфектно качество на сглобяване и с това гарантирана предавателна производителност. За 360° екраниране, само вграденият клин се заключва, като се избягва времеемкото прикрепяне на кабелна връзка. Специалната контактна геометрия в комбинация с 50 μ" златно покритие гарантира 4PPoE според IEEE 802.3bt при всички условия. Материалът на корпуса е направен от никелиран цинков леяр и така отговаря на най-високите екологични и механични изисквания. В комбинация със съвместимата по дизайн модулна поставка е възможна комбинация с всички програми за превключване. Различни сертификации от независими изпитвателни лаборатории допълват най-високите изисквания за качество на модула fixLink<sup>®</sup> SL Keystone. Те се доставят в екологично чиста картонена опаковка.',
        ghmtCertificates: [
          {
            name: 'Сертификат PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/z5951i-20.pdf',
          },
          {
            name: 'Доклад за теста 4PoE според DIN EN ISO/IEC 17025',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/P4712a-17-D.pdf',
          },
          {
            name: 'GHMT Сертификат за постоянна връзка',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/z8144a-23.pdf',
          },
        ],
      },
      fixLinkSLGewinkelt: {
        name: 'SL RJ45 Keystone модул ъглов Cat.6A ISO/IEC, екраниран',
        text: 'С fixLink<sup>®</sup> SL RJ45 Keystone модула под ъгъл, потребителите получават модул RJ45 гнездо от най-високо качество, специално проектиран за приложения с ограничено пространство. Поради наклона на кабелния изход от 75°, модулът е особено подходящ за употреба в данни разклонения и кабелни инсталации в празнини. Минималната дълбочина на инсталация от 27 мм позволява почти неограничено разнообразие от приложения. FixLink® SL RJ45 Keystone модула може да бъде сглобен със странични резци за по-малко от минута. Благодарение на свободно достъпната контактна зона е гарантирано перфектно качество на сглобяване и с това гарантирана предавателна производителност. Специалната контактна геометрия в комбинация с 50 μ" златно покритие гарантира PoE+ според IEEE 802.3at при всички условия. Материалът на корпуса е направен от никелиран цинков леяр и така отговаря на най-високите екологични и механични изисквания. В комбинация със съвместимата по дизайн модулна поставка е възможна комбинация с всички програми за превключване. Различни сертификации от независими изпитвателни лаборатории допълват най-високите изисквания за качество на модула fixLink<sup>®</sup> SL Keystone. Те се доставят в екологично чиста картонена опаковка.',
        ghmtCertificates: [
          {
            name: 'GHMT сертификат PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z5951i-20.pdf',
          },
          {
            name: 'GHMT Сертификат за постоянна връзка',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z8144a-23.pdf',
          },
        ],
      },
      werkzeugeUndZubehoer: {
        name: 'Инструменти и аксесоари',
        text: [
          'Инструмент за сваляне на изолация за премахване на външния кожух и металните фолия на кабел за данни. Син цвят.',
          'Медна лента за фиксиране на екраниращата оплетка. Предварително нарязана на 35 x 9 мм. Опаковка: 20 броя/торба 1500 броя/ролка',
          'Цветни прахозащитни капачки за модулите preLink® SL и fixLink® SL Keystone.',
          'Опаковка 50 броя/полиетиленова торбичка',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP Кат.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z5951i-20.pdf',
          },
          {
            name: 'Сертификат GHMT Permanent Link',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z8144a-23.pdf',
          },
        ],
      },
      verlegekabel: 'Инсталационен кабел',
      goldCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабел за данни EasyLan® Gold S/FTP AWG22/1 1500 MHz Кат. 7A',
        text: [
          'Кабел за данни за пренос на аналогови и цифрови сигнали при окабеляване в първичната, вторичната и третичната област. Подходящ за приложения до клас FA.',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/z7566f-22.pdf',
          },
          {
            name: 'Сертификат GHMT Permanent Link',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/z8144a-23.pdf',
          },
        ],
        datasheets: [
          {
            name: 'Технически лист',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/ZN-DK210304_J_EasyLan_Datasheet_Data_Cable_S-FTP_Gold_AWG22_Cat7A_1500MHz.pdf',
          },
        ],
      },
      silberCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабел за данни EasyLan® Silber S/FTP AWG23/1 1200 MHz Кат. 7A',
        text: [
          'Кабел за данни за пренос на аналогови и цифрови сигнали при окабеляване в първичната, вторичната и третичната област. Подходящ за приложения до клас FA.',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Silber/z7565e-22.pdf',
          },
        ],
        datasheets: [
          {
            name: 'Технически лист',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Silber/ZN-DK210305_J_EasyLan_Datasheet_Data_Cable_S-FTP_Silver_AWG23_Cat7A_1200MHz.pdf',
          },
        ],
      },
      bronzeCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабел за данни EasyLan® Bronze S/FTP AWG23/1 1000 MHz Кат. 7',
        text: 'Кабел за данни за пренос на аналогови и цифрови сигнали при окабеляване в първичната, вторичната и третичната област. Подходящ за приложения до клас FA.',
        datasheets: [
          {
            name: 'Технически лист',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Bronze/ZN-DK210306_L_EasyLan_Datasheet_Data_Cable_S-FTP_Bronze_AWG23_Cat7_1000MHz.pdf',
          },
        ],
      },
      datendosen: 'Данни разклонения',
      csm_Abdeckrahmen_1fach_d4075872d1: {
        name: 'Надстройка за монтаж и рамка за посочените модулни поставки',
        text: [
          'Надстройка за монтаж IP20, 80x80x42mm за инсталиране на EasyLan модулни поставки',
          'Междинна рамка за надстройка за монтаж за увеличаване на височината с 10mm',
          'Единична рамка 80x80mm',
          'Двойна рамка 80x150mm',
        ],
        datasheets: [
          {
            name: 'Надстройка за монтаж',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/AP-Geh%C3%A4use+und+Rahmen+f%C3%BCr+vorgenannte+Modulaufnahmen/ZN-CU161044_B_ADZ00101_EasyLan_Datasheet_Aufputzgeha%CC%88use.pdf',
          },
          {
            name: 'Удължаване на дълбочината за надстройка за монтаж',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/AP-Geh%C3%A4use+und+Rahmen+f%C3%BCr+vorgenannte+Modulaufnahmen/ZN-CU161045_B_CKVDDR90_EasyLan_Datasheet_Tiefenerweiterung_AP-Geha%CC%88use.pdf',
          },
        ],
      },
      csm_Datendose_1PortmitRahmen_a8e4d5e731: {
        name: 'Държач за модул SL, 45° изход UP, BK, AP, BT 1-кратен, 2-кратен, 3-кратен',
        text: 'Модулните поставки SL са особено подходящи за инсталиране в кабелни канали (EK), за вграждане (UP) и за надстройка за монтаж (AP). Чрез отстраняване на два монтажни щифта е възможно монтажът в пода (BT). Модулната поставка SL може да приеме сигурно и трайно от един до три EasyLan кийстоун модула. Тя има голям централно разположен прозорец за маркиране за лесно идентифициране. Централната плоча (50x50 mm) и рамката (80x80 mm) са направени от UV-устойчив и изключително устойчив на счупване пластмаса. Това гарантира дълготрайно и цветово верно излъчване.',
      },
      csm_Datendose_designfähig_1fach_f35757e7bc: {
        name: 'Проектиран модулен държач SL, 45° изход НАГОРЕ, BK, AP, BT 1-кратен, 2-кратен',
        text: 'Дизайн-способната модулна поставка се състои от рамка от цинково леярство. Тя е подходяща за инсталиране в кабелен канал (EK), за вграждане (UP) или с отделна рамка за надстройка за монтаж (AP). Чрез отстраняване на два монтажни щифта е възможно монтажът в пода (BT). Дизайн-способната данни разклонение може да бъде комбинирана с почти всички налични на пазара програми за превключване. Поради съвместимостта с UAE, дизайн-способната данни разклонение не предоставя място за капак против прах.',
        datasheets: [
          {
            name: '1-/2-посочен кийстоун, без централна плоча',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL151005_F_CKVD1DS_EasyLan_Datasheet_designfa%CC%88hige_Modulaufnahme_1-_2-fach_ohne_ZP.pdf',
          },
          {
            name: '2-посочен кийстоун, с централна плоча 50x50mm',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL151006_E_EasyLan_CKVD1D1_Datasheet_designfa%CC%88hige_Modulaufnahme_SL_2-fach_mit_ZP.pdf',
          },
          {
            name: '1-посочен с централна плоча',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL161067_B_EasyLan_CKVD1D2_Datasheet_designfa%CC%88hige_Modulaufnahme_SL_mit_ZP_1-fach.pdf',
          },
        ],
      },
      csm_IP44_AP_Dose_offen_2e48717c62: {
        name: 'Държач за модул IP44 повърхностен монтаж, 1-кратен, 2-кратен',
        text: 'Здравият корпус за надстройка за монтаж е подходящ за инсталиране на два preLink<sup>®</sup> / fixLink<sup>®</sup> Keystone модула. За въвеждане на два кабела с диаметър от 5,0 - 9,5mm всяка, отзад на кутията има две лесни за пробиване точки. Модулната поставка достига клас на защита IP20 при включване и IP44 при затваряне.',
      },
      DoseUPleer2xKS: {
        name: 'Държач за модул, прав изход, 2-кратен',
        text: 'Модулната поставка с прав изход на кийстоуна се състои от рамка от цинково леярство и е подходяща за инсталиране в кабелен канал (EK), за вграждане (UP) или с отделна рамка за надстройка за монтаж (AP).',
      },
      bodentank: 'Подов резервоар',
      csm_Bodentank_2er_Rahmen_fa84a9dd52: {
        name: 'Подови резервоарни системи OBO/Ackermann UT3, UT4',
        text: 'Носещата плоча заменя устройствените носители и така предлага максимално възможно пространство в кабелния водач. Наклоненото подаване и изхвърляне позволява сигурно управление на кабелите дори при много ниски междинни подове. Предвидена е комбинация с монтажни плочи за 4x preLink<sup>®</sup>/fixLink<sup>®</sup> модула или 1x H.D.S. Монтажните плочи се закрепват към носещата плоча с два винта, ненужните полета на носещата плоча могат да бъдат покрити със запушалки против прах.',
        datasheets: [
          {
            name: 'Носеща плоча за UT3 без монтажна плоча',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanksysteme+UT3/ZN-CU161042_C_ABG00011_EasyLan_Datasheet_Bodentanktraegerplatte_UT3.pdf',
          },
          {
            name: 'Носеща плоча за UT4 без монтажна плоча',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanksysteme+UT3/ZN-CU161041_C_ABG00012_EasyLan_Datasheet_Bodentanksystem_UT4.pdf',
          },
        ],
      },
      csm_OBO_Bodentanktraeger_Basic_6x_Kestone_84e5329394: {
        name: 'Основен носител на подов резервоар OBO/Ackermann UT3, UT4',
        text: 'Носителят на кийстоун за подов резервоар заменя устройствения носител и така предлага максимално възможно пространство в кабелния водач. Наклоненото подаване и изхвърляне позволява сигурно управление на кабелите дори при много ниски междинни подове. Монтажните плочи се закрепват към носещата плоча с два винта, ненужните изрезки на носителя на подовия резервоар могат да бъдат покрити със запушалки против прах. С помощта на адаптер, носителят на подовия резервоар може също така да се използва за носители на устройства Electraplan.',
        datasheets: [
          {
            name: 'Носител на подов резервоар UT3 за до 6 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161056_C_ABGECO23_EasyLan_Datasheet_Bodentanktraeger_ECO_UT3_fuer_bis_zu_6_Module.pdf',
          },
          {
            name: 'Носител на подов резервоар UT4 за до 9 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161055_C_ABGECO33_EasyLan_Datasheet_Bodentanktraeger_ECO_UT4_fuer_bis_zu_9_Module.pdf',
          },
          {
            name: 'Носител на подов резервоар UT4 за до 12 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161057_D_ABGECO34_EasyLan_Datasheet_Bodentanktraeger_ECO_UT4_fuer_bis_zu_12_Module.pdf',
          },
        ],
      },
      csm_PUK_Bodentank_3x3KS_2752d44a76: {
        name: 'Основен носител на подов резервоар PUK UT4',
        text: 'Носителят на кийстоун за подов резервоар заменя устройствения носител и така предлага максимално възможно пространство в кабелния водач. Наклоненото подаване и изхвърляне позволява сигурно управление на кабелите дори при много ниски междинни подове. Монтажните плочи се закрепват към носещата плоча с два винта, ненужните изрезки на носителя на подовия резервоар могат да бъдат покрити със запушалки против прах. Носителите на подовия резервоар са съвместими със системата за подови резервоари PUK.',
        datasheets: [
          {
            name: 'Носител на подов резервоар UT4 за до 9 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/PUK+Bodentanktr%C3%A4ger+Basic+UT4/ZN-BL181395_B_ABGPUK33_EasyLan_Datasheet_Bodentanktraeger_PUK_3x3_Keystones.pdf',
          },
          {
            name: 'Носител на подов резервоар UT4 за до 12 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/PUK+Bodentanktr%C3%A4ger+Basic+UT4/ZN-BL181396_B_ABGPUK34_EasyLan_Datasheet_Bodentanktraeger_PUK_3x4_Keystones.pdf',
          },
        ],
      },
      OSO_Einsatz_3xKS: {
        name: 'OBO/Ackermann вложки за подови резервоарни системи UT3, UT4, аксесоари',
        text: 'Вложките за модули са непрашково боядисани и горещо поцинковани поради изискванията за заземяване. Монтажните плочи се закрепват към носещата плоча с два винта, ненужните полета на носещата плоча могат да бъдат покрити със запушалки против прах.',
        datasheets: [
          {
            name: 'Монтажна плоча за 4x RJ45 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Eins%C3%A4tze+f%C3%BCr+Bodentanksysteme+UT3/ZN-CU161043_B_EasyLan_Datasheet_Bodentanktraegereinsatz_4xKS_ABG00014.pdf',
          },
          {
            name: 'Монтажна плоча за 3x RJ45 модула',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Eins%C3%A4tze+f%C3%BCr+Bodentanksysteme+UT3/ZN-CU200571_B_EasyLan_Datasheet_Bodentanktraegereinsatz_3xKS_ABG00016.pdf',
          },
        ],
      },
      hutschienenadapter: 'Адаптери за DIN релса',
      csm_Hutschienenmodul_Kompakt_01_66214719b0: {
        name: 'Компактен модулен корпус за DIN шина за 1 модул',
        text: 'Корпус на DIN шина за модули preLink<sup>®</sup> / fixLink<sup>®</sup>, подходящ за разпределителни шкафове без капак за прекъсвачи.',
        datasheets: [
          {
            name: 'Компактен корпус на модул за DIN релса за 1 модул',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Hutschienen-Modulgeh%C3%A4use+und+-Adapterset/ZN-CU161008_B_CKVHECOMOD_EasyLan_Datasheet_Hutschienenmodulgehaeuse_fuer_Sicherungsautomaten.pdf',
          },
        ],
      },
      KeystoneAdapterFKupplung: {
        name: 'Keystone F-съединител и празна капачка Keystone празен модул',
        text: 'F-съединител и празна капачка като комплект модули\nF-съединителят служи за интегриране на коаксиални кабели в preLink<sup>®</sup> / fixLink<sup>®</sup> пач панели и в програмата за разклонения. Празната капачка preLink<sup>®</sup>/fixLink<sup>®</sup> може да се използва както в полето за разпределение, така и в разклоненията за покриване на неизползвани портове.\n\nПразен модул за SC-S или LC-D като комплект модули\nПразен модул за SC-S- или LC-D-съединители в поле за разпределение или разклонение.',
      },
      csm_Hutschienenmodul_01_32c872ee2e: {
        name: 'Модулен корпус за DIN шина за 1 модул',
        text: 'Модулен корпус за DIN шина за модули preLink<sup>®</sup> / fixLink<sup>®</sup>, подходящ за разпределителни шкафове с капаци за прекъсвачи.',
        datasheets: [
          {
            name: 'Модулен корпус за DIN шина за 1 модул',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Hutschienen-Modulgeh%C3%A4use+und+-Adapterset/ZN-CU200572_B_CKVHMOD_EasyLan_Datasheet_Carrier_Rail_Modular_Housing_for_one_Modul_.pdf',
          },
        ],
      },
      panel: 'Панел',
      csm_1HE_fixLink_Panel_5f97ddb36b: {
        name: 'Панел 19" 1U за 24 Keystone модула с прав изход',
        text: 'Разпределителният панел 19" 1U може да бъде оборудван с до 24 preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone модула. Той е изграден на две нива, така че модулите са вградени в предния панел. Разпределителният панел може да бъде поръчан както от неръждаема стомана, така и от боядисана с прах стоманена ламарина.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      csm_48x_fixLink_Panel_19a5ba2e55: {
        name: 'Панел 19" 1U за 48 модула Keystone, прав изход',
        text: '19" 1U разпределителен панел може да бъде свързан с до 48 модула fixLink<sup>®</sup> Pro / fixLink<sup>®</sup> Pro+ RJ45 keystone. Той е конструиран на две нива, така че модулите са изравнени предния панел Разпределителният панел е изработен от прахово боядисана ламарина.\nМонтажният материал и модулите keystone не са включени в обхвата на доставката.',
      },
      csm_05HE_panel_fixlink_c73fbc8cf9: {
        name: 'Панел 19" 0,5U за 24 Keystone модула с прав изход',
        text: 'Разпределителният панел preLink<sup>®</sup> / fixLink<sup>®</sup> 19" 0,5U може да бъде оборудван с до 24 fixLink<sup>®</sup> RJ45 Keystone модула. Те са вградени в предния панел.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      csm_Beschriftungspanel_70ebc940db: {
        name: 'Панел 19" 1U за 24 Keystone модула включително прозорец за маркиране',
        text: 'Разпределителният панел 19" 1U може да бъде оборудван с до 24 preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone модула. Той е изграден на две нива, така че модулите са вградени в предния панел. Разпределителният панел може да бъде поръчан както от неръждаема стомана, така и от боядисана с прах стоманена ламарина. Допълнително е възможно маркирането на отделните портове с помощта на приложения маркиращ лист с размери 12x33.',
      },
      csm_Winkelpanel_30__22e31b820a: {
        name: 'Наклонен панел 30° 19" 1U за 24 Keystone модула',
        text: 'С наклонения панел preLink<sup>®</sup> / fixLink<sup>®</sup>, потребителят има възможността да постави 24 Keystone модула под ъгъл от 30° в панела, като по този начин свързаните пач кабели автоматично се насочват към страната на шкафа и трябва само да бъдат закрепени до пач нивото. Това позволява на потребителя да се откаже от допълнителни панели за управление на кабели. В експлоатация, наклонените панели с плоска предна страна и наклонени пач кабели също изискват по-малко пространство напред в сравнение с традиционните пач панели с вертикално монтирани портове.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      baugruppentraeger: 'Носител на модули',
      csm_BGT_3HE1_8bf0b66dbe: {
        name: 'Носител на модули 19" 3U за използване на вмъкваеми модули',
        text: 'Носител на модули 19" 3U за използване на 7TE вмъкваеми модули в мед и влакно. Те се фиксират към носителя на модулите с 2 винта от страната на панела. Вмъкваемите модули могат да бъдат напълно извадени от носителя на модулите. Максимум 12x 7TE вмъкваеми модули могат да бъдат прикрепени към носителя на модулите.',
      },
      csm_fixLink_preLink_Einschubmodul_02_b91415f81e: {
        name: 'Keystone вмъкваем модул за носител на модули',
        text: 'Keystone вмъкваем модул за оборудване на носители на модули. Keystone вмъкваемият модул може да бъде оборудван с до 6 preLink<sup>®</sup> или fixLink<sup>®</sup> Keystone модула. Keystone вмъкваемият модул е изграден на две нива, така че модулите са вградени в предния панел. Улавянето на кабелите става директно на корпуса на вмъкваемия модул. Могат да бъдат закрепени 6 индивидуални кабела или 1 трънк кабел.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      csm_Modulträger_1HE_488e9c42e4: {
        name: 'Носител на модули (BGT) 19" 1U за използване на вмъкваеми модули',
        text: 'Носител на модули (BGT) за използване на 7TE вмъкваеми модули в мед и оптично влакно. Те се фиксират към носителя на модулите с 2 винта от страната на панела. Вмъкваемите модули могат да бъдат напълно извадени от носителя на модулите. Максимум 3x 7TE вмъкваеми модули (=18 порта) могат да бъдат прикрепени към носителя на модулите.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      csm_Sidemodulträger_3HE_87268249f6: {
        name: 'Страничен носител на модули 3HE/14TE за използване на вмъкваеми модули',
        text: 'Страничният носител на модули (S-BGT) за използване на 7TE вмъкваеми модули в мед и оптично влакно. Вмъкваемите модули се фиксират към носителя на модулите с 2 винта от страната на панела. Вмъкваемите модули могат да бъдат напълно извадени от носителя на модулите. Максимум 2x 7TE вмъкваеми модули (=12 порта) могат да бъдат прикрепени към носителя на модулите. Монтажът на страничния носител на модули (S-BGT) става на страничното пробиване на шкафа. Това позволява лесен и бърз монтаж. Страничният монтаж на шкафа позволява да се реализира икономично, особено климатично приятно окабеляване, без да се нарушава въздушният поток.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      consolidation_point_panel: 'Точков панел за консолидация, DIN шини и др.',
      csm_CPGehäuse_10___39edc363aa: {
        name: 'Подов консолидационен панел 19" или 10" 1U',
        text: 'Подов консолидационен панел със сменяеми предни плочи за настаняване на различни видове връзки в мед и оптично влакно. По желание, подовият консолидационен панел може да бъде защитен от неоторизиран достъп с ключалка.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
        datasheets: [
          {
            name: 'Консолидационен панел 10"',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Unterflur-Consolidation+Point+Panel+19%22+bzw.+10%22+1HE/ZN-BL151025_B_CPPF01KS1E_Datasheet_EasyLan_CP_Box_10_Zoll_1U.pdf',
          },
          {
            name: 'Консолидационен панел 19"',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Unterflur-Consolidation+Point+Panel+19%22+bzw.+10%22+1HE/ZN-BL151024_B_CPPF09KS1E_Datasheet_EasyLan_CP_Box_19_Zoll_1U.pdf',
          },
        ],
      },
      csm_Unterbaupanel_4x_KS_RAL7035_b8b62c45c1: {
        name: 'Надземен консолидационен панел за 4-12 Keystone модула',
        text: 'Надземен консолидационен панел за preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone модули, за използване като консолидационен панел, директен монтаж или чрез монтажен комплект на DIN релси в електротехнически разпределения. Надземният консолидационен панел е изграден на две нива. Така модулите са вградени в предния панел.\n\nМонтажният материал и модулите Keystone не са включени в обхвата на доставка.',
      },
      trunkkabel: 'Трънк кабел',
      csm_CTBC_Trunkkabel_fixLink_8023e4b1c3: {
        name: 'SL CTBC разпределителна система меден магистрален пакетен кабел, клас EA ISO/IEC',
        text: 'CTBC разделителната система е подходяща за гъвкаво използване в структурирано сградно окабеляване и в данни центрове. Кабелите, събрани в оплетка, са фабрично оборудвани с fixLink<sup>®</sup> Keystone модули и тествани. Сгъстяването може да се извърши както с инсталационни кабели, така и с гъвкави кабели. Максималната дължина на сгъстения кабел е до 20 м.',
      },
      csm_CTCC_Trunkkabel_fixLink_efb2b05f62: {
        name: 'SL CTCC разпределителна система меден магистрален компактен кабел, клас EA ISO/IEC',
        text: 'CTCC разделителната система е подходяща за гъвкаво използване в структурирано сградно окабеляване и в данни центрове поради минималния си диаметър на кабела и съответно ниската огнената натовареност. Максималната дължина на многожилния кабел варира в зависимост от типа между 60-90 м. Разделителната система като 10-Gbit решение за окабеляване на данни центрове отговаря поне на изискванията на категория EA.',
      },
      hds_innengabel: 'H.D.S. Вътрешен кабел',
      csm_HDS_Innenkabel01_4cd8e032b6: {
        name: 'H.D.S. Вътрешен кабел Cat. 7, 6x (4 x 2 x AWG 23) S-FTP B2ca, S-FTP Dca',
        text: 'H.D.S. Вътрешен кабел Cat. 7 S/FTP за лесно свързване от шкаф до шкаф в данни центрове и мултивръзки от разпределителни стаи към подразпределения. Структурата на кабела се състои от 24 двойки екранирани кабелни елементи, 4 двойки са комбинирани в един елемент за скрутка. Всеки елемент за скрутка е маркиран с номерна лента за по-лесна идентификация. Гъвкавият централен елемент за облекчаване на напрежението осигурява особено добра защита на кабела при влачене. Обвивката е направена от гъвкав материал LSOH.',
      },
      csm_HDS_Innenkabel01_4cd8e032b7: {
        name: 'H.D.S. Вътрешен кабел Cat. 7 6x (4 x 2 x AWG 26) S-FTP Dca',
        text: 'H.D.S. Вътрешен кабел Cat. 7 S/FTP за лесно свързване от шкаф до шкаф в данни центрове и мултивръзки от разпределителни стаи към подразпределения. Структурата на кабела се състои от 24 двойки екранирани кабелни елементи, 4 двойки са комбинирани в един елемент за скрутка. Всеки елемент за скрутка е маркиран с номерна лента за по-лесна идентификация. Гъвкавият централен елемент за облекчаване на напрежението осигурява особено добра защита на кабела при влачене. Обвивката е направена от гъвкав материал LSOH.',
      },
      generic: {
        download: 'Изтегляне',
      },
    },
  },

  imprint: {
    headline: 'Импресум',
  },

  dataProtection: {
    headline: 'Защита на данните',
  },

  footer: {
    dataProtection: 'Защита на данните',
    imprint: 'Импресум',
    contact: 'Контакт',
  },

  UI: {
    autocomplete: {
      searchError: 'Търсенето не може да бъде извършено.',
      searchEmpty: 'Няма резултати',
    },
    dropdown: {
      emptySelection: '--- моля изберете ---',
    },
  },
}

export const langKey = 'BG'

const Default = {
  translation,
  langKey,
}

export default Default
